var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDryFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 10,
    x2: 54,
    y1: 8,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bag",
    x1: 20,
    x2: 43,
    y1: 11,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BCB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#159447"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bag)",
    d: "M21 12h22l3 37H18l3-37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E6F38",
    d: "M23 12h18v7H23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF8E8",
    d: "M24 24h16v14H24z",
    opacity: 0.96
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F59E0B",
    d: "M27 29c0-3 2-5 5-5s5 2 5 5-2 5-5 5-5-2-5-5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C4A18",
    d: "M11 41c3-4 9-6 16-6s13 2 16 6v6c0 5-7 9-16 9s-16-4-16-9v-6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A16207",
    d: "M15 42c3-2 7-3 12-3s9 1 12 3c-3 2-7 4-12 4s-9-2-12-4Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 43,
    r: 2.2,
    fill: "#EAB308"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 41,
    r: 2.1,
    fill: "#F97316"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 44,
    r: 2,
    fill: "#EAB308"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryFood);
export default __webpack_public_path__ + "static/media/dry-food.00dbab222b1e405ebe6eeb480ecea324.svg";
export { ForwardRef as ReactComponent };